import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	templateUrl: 'missing.component.html',
	standalone: false,
})
export class MissingComponent implements AfterViewInit {
	private _homerUrl: any;

	@ViewChild('test')
	private player;

	constructor(sanitizer: DomSanitizer) {
		this._homerUrl = sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/cnaeIAEp2pU?t=4&autoplay=1');
	}

	ngAfterViewInit() {
		if (this.player) {
			console.log('');
		}
	}

	get homerUrl(): any {
		return this._homerUrl;
	}
}
